import {
    Button,
  } from "reactstrap";

function InfoDisplayer({allInfo}) {

    const isComplete = (info) => {
        if (!info.firstName || !info.lastName || !info.email || !info.category) return false
        return true
    }

/*     const calcPrice = (info) => {
        if (info.category.includes('INSA') || info.category.includes('Diplômé')) return '40€'
        if (info.category.includes('UPHF')) return '42€'
        if (info.category.includes('Exté')) return '50€'
    } */

    return (
        <>
            {allInfo.map((info, index) => {
        return  <Button key={index} size="sm" color={isComplete(info) ? "success" : "danger"}>
                    {(index < 1 ? <strong>Moi</strong> : <strong>Invité {index}</strong>)} : {info.firstName} {info.lastName} - {info.email} - {info.category} - {info.price}€
                </Button>
})}
        </>
    )
}

export default InfoDisplayer
